var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost-estimate"},[_c('Permissioned',{attrs:{"section":"bookings.view","vertical":""}},[_c('HourlyCost',{attrs:{"permission":"worker-cost"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }